module.exports = __webpack_public_path__ + "img/box7-7.d6c7c73a.png";